import { of } from "rxjs"

import { switchMap } from "rxjs/operators"
import { ofType } from "redux-observable"

import * as types from "./actionTypes"
import * as loaderActions from "./actions"

export const showLoader = (action$) =>
    action$.pipe(
        ofType(types.SHOW_LOADER),
        switchMap(() => of(loaderActions.setLoader(true)))
    )
export const hideLoader = (action$) =>
    action$.pipe(
        ofType(types.HIDE_LOADER),
        switchMap(() => of(loaderActions.setLoader(false)))
    )
